<template>
  <designer-home v-if="is_designer"/>
  <admin-home v-else/>
</template>

<script>
// @ is an alias to /src
import AdminHome from "./AdminHome";
import DesignerHome from "@/views/designer/panel/Dashboard"

export default {
  name: "Home",
  components: { AdminHome, DesignerHome },
  data() {
  },
  computed: {
    is_designer() {
      return this.$acl.isDesigner
    }
  },
  mounted() {
    if (this.$store.state.layout != "app-layout") this.$setLayout("app-layout");
  },
};
</script>
